import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const isApi = (url) => typeof url === 'string' && (url.startsWith(`${API_BASE}/api`) || url.startsWith('/api'));

// Attach the session token to every backend API call that does not already carry one.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token && isApi(config.url) && !config.headers?.Authorization) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  }
  return config;
});

const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const url = typeof input === 'string' ? input : input?.url;
  const token = localStorage.getItem('auth_token');
  if (token && isApi(url)) {
    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    return nativeFetch(input, { ...init, headers });
  }
  return nativeFetch(input, init);
};
